import React from "react";
import { Dimensions, StyleSheet, View, Platform, Text, TouchableOpacity } from "react-native";
import { PictureData } from "../types/types";
import ParallaxCarousel from "./ParallaxCarousel";
import { Card, MD3Theme, useTheme } from "react-native-paper";
import { mobAlert } from "../mobx/MobAlert";
import { SafeAreaView } from "react-native-safe-area-context";

interface ImageGalleryProps {
  pictureData: PictureData
}

const picSize = Dimensions.get("screen").width * 0.73;

export default function ImageGallery({ pictureData }: ImageGalleryProps) {

  const theme = useTheme();
  const styles = stylesGen(theme);

  const imageUrls = pictureData?.pictures.map((img) => ({
    url: `${img.container}/${img.name}`,
  }));

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      {Platform.OS === 'web' ? (
        <View style={styles.webContainer}>
          {pictureData?.pictures.map((img, _idx) => (
            <TouchableOpacity key={_idx} onPress={() => mobAlert.setImageModal(_idx, imageUrls)}>
              <Card style={styles.image}>
                <img src={`${img.container}/${img.name}`} alt={img.title} style={styles.webImage} />
              </Card>
            </TouchableOpacity>
          ))}
        </View>
      ) : (
        <Card>
          <ParallaxCarousel
            data={pictureData?.pictures.map((img, _idx) => {
              img["uri"] = `${img.container}/${img.name}`;
              return img;
            })}
            itemWidth={styles.image.width}
            itemHeight={styles.image.height}
          />
        </Card>
      )}
    </SafeAreaView>
  );
}

const stylesGen = (theme: MD3Theme) => StyleSheet.create({
  image: {
    width: picSize,
    height: picSize,
    overflow: 'hidden'
  },
  webContainer: {
    justifyContent: 'center',
    gap: 20,
    paddingBottom: 20,
  },
  webImage: {
    width: '100%',
    height: '100%',
  },
  imageDescription: {
    color: theme.colors.onBackground,
    marginTop: picSize * 0.1,
    fontFamily: "NotoSans-Bold",
    fontSize: 18,
    textAlign: "center",
    textTransform: "uppercase"
  },
});
